{
  "base": "Rapportering",
  "segment": {
    "budget": "Budsjett og revisorstadfesting",
    "funds": "Tildelte midlar",
    "administration": "Gjennomføring og administrasjon",
    "esa": "ESA-rapportering",
    "declaration": "Eigenerklæring",
    "goals": "Måltal",
    "registration": "Registrering",
    "timeline": "Status",
    "confirmation": "Kvittering",
    "summary": "Oppsummering",
    "feedback": "Tilbakemelding",
    "approved": "Godkjende måltal",
    "achieved": "Måloppnåing",
    "companies": "Bedriftsnivå",
    "operator": "Operatørnivå",
    "activities": "Aktivitetar",
    "edit": "Rediger",
    "deadlines": "Fristar"
  },
  "title": {
    "index": "Rapportering",
    "budget": "Budsjett og revisorstadfesting",
    "goals": "Måltal",
    "goalsYear": "Måltal {{year}}",
    "achieved": "Måloppnåing",
    "achievedYear": "Måloppnåing {{year}}",
    "funds": "Tildeling og bruk av midlar",
    "fundsYear": "Tildelte midlar {{year}}",
    "administrationYear": "Gjennomføring og administrasjon {{year}}",
    "declaration": "Eigenerklæring",
    "declarationYear": "Eigenerklæring {{year}}",
    "deadlines": "Fristar Siva",
    "confirmation": "Sendt inn",
    "feedback": "Oppsummering",
    "esa": "ESA-rapportering",
    "esaYear": "ESA-rapportering {{year}}"
  },
  "lead": {
    "funds": "Oversikt over gjennomføring og administrasjon og bruk av ESA-rapportering (artikkel 28)"
  },
  "goals": {
    "introSections": "Måltal for {{year}} består av desse seksjonane:",
    "introQuestionCount": "Det er totalt {{questionCount}} spørsmål og alle må svarast på. Vi råder deg til å leggje inn ein kommentar dersom det er nødvendig å grunngje talet.",
    "introDeadline": "Endeleg svarfrist er 1. desember {{year}}",
    "introShow": "Vis måltal {{year}}",
    "confirmationSubmittedAt": "Måltal {{year}} vart sendt inn {{date}}",
    "confirmationSupport": "Har du tekniske spørsmål kan du sende e-post til flerbedriftsportal@innovasjonnorge.no",
    "confirmationViewGoals": "Sjå måltal {{year}}",
    "closedForReporting": "Måltal kan ikkje leggjast inn for {{year}} fordi rapportåret er stengt for innrapportering.",
    "noGoalsFound": "Fann ingen mål for {{year}}.",
    "lastSaved": "Sist lagra {{timestamp}}",
    "sections": "Seksjonar",
    "autoSaveNotice": "Skjemaet blir lagra undervegs.",
    "categoryIntro": "Alle tal og prosentar gjeld for år {{year}} og er obligatoriske. Vi råder deg til å leggje inn kommentarar for å forklare måltala, spesielt dersom det er eit stort avvik frå fjoråret.",
    "summaryHeading": "Oppsummering",
    "showDescription": "Vis skildring",
    "commentOptional": "Kommentar (valfritt)",
    "previousYearValue": "Måltal frå {{year}}: {{value}}",
    "editGoal": "Rediger måltal {{name}}",
    "sivaComment": "Kommentar frå Siva",
    "originalValue": "Opphavleg måltal",
    "updateError": "Kunne ikkje oppdatere måltal",
    "loadError": "Kunne ikkje hente ut måltal",
    "submitError": "Kunne ikkje sende inn måltal",
    "submitUpdatedError": "Kunne ikkje sende inn oppdaterte måltal",
    "noFeedbackTitle": "Vi beklagar, det har skjedd ein feil.",
    "noFeedbackBody": "Det er ikkje registrert at de har fått tilbakemelding på noko måltal. De kan berre oppdatere måltal de har fått tilbakemelding på. Send inn slik at Siva kan leggje inn tilbakemeldingar.",
    "status": {
      "saved": "Lagra",
      "savedBody": "Måltal {{year}} er lagra {{timestamp}}",
      "savedLink": "Rediger måltal {{year}}",
      "submitted": "Sendt til Siva",
      "submittedBody": "Måltal {{year}} vart sendt til Siva og måltala kan ikkje endrast",
      "feedback": "Tilbakemelding frå Siva",
      "feedbackBody": "Etter gjennomgang av måltala har Siva gitt tilbakemeldingar på måltal {{year}}",
      "feedbackLink": "Sjå tilbakemeldingar frå Siva",
      "approved": "Godkjent",
      "approvedBody": "Måltal {{year}} har blitt godkjent av Siva",
      "viewGoals": "Sjå måltal {{year}}"
    }
  },
  "achieved": {
    "total": "Total måloppnåing",
    "downloadReport": "Last ned oversiktsrapport",
    "updateAllGoals": "Oppdater alle mål",
    "editAchievement": "Rediger måloppnåing",
    "levels": "Nivå",
    "viewDetails": "Vis detaljar",
    "valueLabel": "Verdi",
    "value": "Verdi: {{value}}",
    "goalValue": "Måltal: {{value}}",
    "ofTotal": "av {{total}}",
    "progressLabel": "{{name}}: {{value}} av {{expected}}",
    "autoSaved": "Endringane er autolagra kl. {{time}}",
    "endEditing": "Avslutt redigering",
    "goalForYear": "Måltal {{year}}: {{value}}",
    "editedConfirmation": "Måloppnåinga er redigert.",
    "srlDescription": "Det skal angjevast kva SRL-nivå bedrifta er på per 31.12 (eller då bedrifta gjekk ut av program i løpet av året). Klikk på oransje spørsmålsteikn for å sjå skildringa av dei ni trinna i SRL-skalaen.",
    "euDescriptionScope": "Det skal registrerast om bedrifta bidreg til vesentleg eller potensiell vesentleg positiv effekt på eitt eller fleire av dei 6 miljømåla i EU-taksonomien. Det skal også registrerast om bedrifta bidreg til vesentleg eller potensiell vesentleg skade på nokon av dei same måla (jf. prinsippet om «Do no significant harm»). Dersom bedrifta ikkje bidreg til korkje vesentlege positive eller negative effektar, hakar de av for “Ingen”. Dersom de er i tvil om bedrifta bidreg til vesentlege positive eller negative effektar, kryssar de av for «ingen».",
    "euDescriptionHelp": "Klikk på oransje spørsmålsteikn for å sjå skildringa av dei seks miljømåla, samt kva som krevst for å bidra til (potensiell) vesentleg positiv eller negativ miljøeffekt.",
    "euDescriptionCalculation": "Måltalet er angjeve som del av bedriftene som har (potensielt) vesentleg positivt bidrag på minst eitt av måla. Kriteriet om (potensiell) vesentleg skade har ikkje påverknad på utrekninga av måloppnåing."
  },
  "funds": {
    "tableCaption": "Tildelte midlar {{year}}",
    "article28": "Artikkel 28",
    "preIncubation": "Preinkubasjon",
    "otherPhases": "Øvrige fasar",
    "administration": "Gjennomføring og administrasjon",
    "totalAllocated": "Sum tildelte midlar {{year}}"
  },
  "deadline": {
    "finishAnnualReporting": {
      "title": "Ferdigstill årsrapportering",
      "description": "All rapportering for føregåande år må vere ferdigstilt i Flerbedriftsportalen"
    },
    "uploadGoals": {
      "title": "Last opp måltal",
      "description": "Opplasting av måltal for inneverande år i Flerbedriftsportalen"
    },
    "regionalReporting": {
      "title": "Send inn regionalrapportering",
      "description": "Skjema for regionalrapportering skal fyllast ut og sendast til Innovasjon Noreg"
    },
    "uploadAuditorConfirmation": {
      "title": "Last opp revisorstadfesting",
      "description": "Opplasting av revisorstadfesting på totale kostnader brukte på gjennomføring og administrasjon knytt til programaktiviteten i fjor (ikkje statsstøtte). Bruk mal frå Innovasjon Noreg"
    },
    "ktuUpdate": {
      "title": "KTU-oppdatering: Legg inn nye opptak og exit",
      "description": "Oppdatere Flerbedriftsportalen med nye opptak og avslutta bedrifter"
    },
    "reportArticle28FirstHalf": {
      "title": "Rapporter innovasjonsstøtte (art 28) første halvår",
      "description": "Rapportering av bruk av innovasjonsstøtte (artikkel 28) per første halvår"
    },
    "uploadBudget": {
      "title": "Last opp budsjett for komande år",
      "description": "Opplasting av budsjett for gjennomføring og administrasjon for komande år. Bruk mal frå Innovasjon Noreg"
    },
    "registerActiveCompanies": {
      "title": "Siste frist for å leggje inn alle aktive bedrifter for i år",
      "description": "Alle bedrifter som er/har vore aktive i løpet av året må vere registrerte i Flerbedriftsportalen"
    }
  },
  "invalidYear": "Ugyldig årstal",
  "selectYear": "Vel år"
}
